<template>
  <div class="mobile">
    <h1>grow up.</h1>
    <img v-if="gif" :src="gif" alt="awesome gif">
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'Mobile',
  data() {
    return {
      gif: null
    }
  },
  mounted(){
    axios.get('http://api.giphy.com/v1/gifs/random?api_key=dc6zaTOxFJmzC&tag=fail')
    .then(res => {
      this.gif = res.data.data.image_original_url
    })
  }
}
</script>

<style lang="scss">
  .mobile{
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    h1{
      font-size: 2.5rem;
      font-family: var(--conduitITC);
      margin-bottom: 20px;
    }
    img{
      width: 70vw;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Mobile.vue